import { toast } from 'react-toastify';
import ApiDatabase from 'server';

/**
 * Sends a member their invitation to a company again (the account still
 * waits for its first sign-in), and says so in a toast. Shared by the
 * company's contacts and the contact's « Entreprise » tab.
 */
const resendInvitation = ({ companyId, memberId, email }) =>
  ApiDatabase.postSendMailLinkCompanyEmployee(
    { idCompany: companyId, idEmployee: memberId },
    () => toast.success(`Invitation renvoyée à ${email}`),
    (error) => {
      console.error('[resendInvitation]', error?.response?.status);
      toast.error('L’invitation n’a pas pu être renvoyée. Réessayez.');
    },
  );

export default resendInvitation;
